import { render } from "./ApiKeyPairPermissionTable.vue?vue&type=template&id=f8c14e9e&scoped=true"
import script from "./ApiKeyPairPermissionTable.vue?vue&type=script&lang=js"
export * from "./ApiKeyPairPermissionTable.vue?vue&type=script&lang=js"

import "./ApiKeyPairPermissionTable.vue?vue&type=style&index=0&id=f8c14e9e&lang=scss&scoped=true"

import exportComponent from "/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8c14e9e"]])

export default __exports__